import React from 'react'

import { Separator } from '@components/Separator'
import { useSiteFeatures } from '@hooks/siteFeatures'

import { DownstreamData } from './Data/Downstream'
import { MidstreamData } from './Data/Midstream'
import { DataContainer, Paper, SeparatorContainer } from './styles'
import { ViewComments } from './ViewComments'

interface IProps {
  onCommentIconClick: () => void
}

export function TaskCard({ onCommentIconClick }: IProps) {
  const { isMidstreamProcess } = useSiteFeatures()

  return (
    <Paper>
      <DataContainer>
        {isMidstreamProcess ? <MidstreamData /> : <DownstreamData />}
      </DataContainer>

      <SeparatorContainer>
        <Separator />
      </SeparatorContainer>

      <ViewComments handlePress={onCommentIconClick} />
    </Paper>
  )
}
